<template>
  <v-dialog
    v-model="show"
    @click:outside="$emit('cancel')"
  >
    <v-card
      light
      :class="position"
    >
      <v-card-title v-text="__('quantity')" />
      <v-card-text>
        <v-row class="mx-0 my-2">
          <v-col cols="8">
            <v-row>
              <v-text-field
                ref="quantityField"
                :value="quantity"
                type="number"
                outlined
                hide-details
                :min="min"
                :max="max"
                style="max-width: 120px;"
                @input="setQuantity($event)"
                @keyup.enter="done()"
              />
              <nav class="ml-1">
                <div>
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="increment()"
                  >
                    <v-icon v-text="icons.plusCircle" />
                  </v-btn>
                </div>
                <div>
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="decrement()"
                  >
                    <v-icon v-text="icons.minusCircle" />
                  </v-btn>
                </div>
              </nav>
            </v-row>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn
              fab
              small
              depressed
              color="primary"
              @click="done()"
            >
              <v-icon v-text="icons.done" />
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      min: {
        required: false,
        type: Number,
        default: 1,
      },
      max: {
        required: false,
        type: Number,
        default: 100,
      },
      initial: {
        required: false,
        type: Number,
        default: 1,
      },
    },

    data: () => ({
      quantity: undefined,
      position: '',
    }),

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
      initialInRange () {
        return this.initial >= this.min && this.initial <= this.max
      },
    },

    watch: {
      show (v) {
        if (v) {
          this.setQuantity(this.initialInRange ? this.initial : this.min)
          setTimeout(() => this.$refs.quantityField.focus(), 50)
          setTimeout(() => this.position = 'qty-card', 250)
        } else {
          this.position = ''
        }
      },
    },

    methods: {
      increment () {
        if (this.quantity < this.max) {
          this.setQuantity(this.quantity + 1)
        }
      },
      decrement () {
        if (this.quantity > this.min) {
          this.setQuantity(this.quantity - 1)
        }
      },
      setQuantity (v) {
        this.quantity = parseInt(v)
      },
      done () {
        this.$emit('submit', this.quantity)
        this.show = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .qty-card {
    position: absolute;
    top: 96px;
    left: 5vw;
    width: 90vw;
    max-width: 320px;
  }
</style>
